import { Component, Renderer2, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, Observable, Subscription } from 'rxjs';
import { userInfo } from '../../store/model/user.models';
import { selectIsAuthenticated } from '../../store/selectors/auth.selectors';
import { ContextService } from '../services/context.service';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { NavigationEnd, Router } from '@angular/router';
import { TopBarComponent } from './top-bar/top-bar.component';


@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
    standalone: false
})
export class DashboardComponent {

  @ViewChild(LeftMenuComponent) appLeftBar!: LeftMenuComponent;

  @ViewChild(TopBarComponent) appTopbar!: TopBarComponent;

  overlayMenuOpenSubscription: Subscription;

  authStatus$: Observable<any | null>;
  menuOutsideClickListener: any;
  profileMenuOutsideClickListener: any;


  constructor(private store: Store, public context: ContextService, public renderer: Renderer2, public router: Router) {
    this.overlayMenuOpenSubscription = this.context.overlayOpen$.subscribe(() => {
      if (!this.menuOutsideClickListener) {
        this.menuOutsideClickListener = this.renderer.listen('document', 'click', event => {
          const isOutsideClicked = !(this.appLeftBar.el.nativeElement.isSameNode(event.target) || this.appLeftBar.el.nativeElement.contains(event.target)
            || this.appTopbar.menuButton.nativeElement.isSameNode(event.target) || this.appTopbar.menuButton.nativeElement.contains(event.target));
          if (isOutsideClicked) {
            this.hideMenu();
          }
        });
      }


      if (this.context.state.staticMenuMobileActive) {
        this.blockBodyScroll();
      }

      this.router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
          this.hideMenu();
          this.hideProfileMenu();
        });


    });

    this.authStatus$ = this.store.select(selectIsAuthenticated)
  }

  ngOnInit(): void {
  }

  hideMenu() {
    this.context.state.overlayMenuActive = false;
    this.context.state.staticMenuMobileActive = false;
    if (this.menuOutsideClickListener) {
      this.menuOutsideClickListener();
      this.menuOutsideClickListener = null;
    }
    this.unblockBodyScroll();
  }

  hideProfileMenu() {
    this.context.state.profileSidebarVisible = false;
    if (this.profileMenuOutsideClickListener) {
      this.profileMenuOutsideClickListener();
      this.profileMenuOutsideClickListener = null;
    }
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    }
    else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    }
    else {
      document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
        'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }

  get containerClass() {
    return {
      'layout-theme-light': this.context.config().colorScheme === 'light',
      'layout-theme-dark': this.context.config().colorScheme === 'dark',
      'layout-overlay': this.context.config().menuMode === 'overlay',
      'layout-static': this.context.config().menuMode === 'static',
      'layout-static-inactive': this.context.state.staticMenuDesktopInactive && this.context.config().menuMode === 'static',
      'layout-overlay-active': this.context.state.overlayMenuActive,
      'layout-mobile-active': this.context.state.staticMenuMobileActive,
      'p-input-filled': this.context.config().inputStyle === 'filled',
      'p-ripple-disabled': !this.context.config().ripple
    }
  }
}
